import { FilIcon } from './src/fil-icon.component.js';

customElements.define('fil-icon', FilIcon);
